<template>
  <div style="height:100%;">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/welfarelist' }">返回</el-breadcrumb-item>
      <el-breadcrumb-item>福利发放</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="welfare-main">
      <div class="top-menu">
        <div class="name-value">
          已选择<span>{{matesCount}}</span> 福利发放总金额（元）：<span>{{parseFloat(allMoney).toFixed(2)}}</span>
        </div>
        <el-button type="success" class="btn" @click="addMatesClick">添加福利人员</el-button>
        <el-button
          type="primary"
          class="btn"
          @click="ensureVisible = true"
          :disabled="submitMates.length<=0"
        >提交申请</el-button>

      </div>
      <div class="welfare-bottom">
        <!--  -->
        <el-card class="wel-item" v-for="(mates,index) in submitMates" :key="index">
          <div class="head-container">
            <div class="mate" v-for="i in mates" :key="i.userId">
              <i class="el-icon-error" @click="removeMate(i,index)"></i>
              <div class="avatar">{{(i.realname).substring(0,1)}}</div>
              <div class="name-money">
                <div class="name">{{i.realname}}</div>
                <div class="money">{{parseFloat(i.amount).toFixed(2)}}</div>
              </div>
            </div>
          </div>
          <div class="tip">备注：{{mates[0].desc}}</div>
        </el-card>

        <div class="empty-view" v-if="submitMates.length<=0">
          <img src="../../assets/empty.png">
          <p>选择人员发放福利吧</p>
        </div>
      </div>
    </div>

    <el-dialog title="确定提交本次福利发放申请？" :visible.sync="ensureVisible" width="30%">
      <span>
        提交福利发放申请后，将由福利审核人进行审核
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="ensureVisible = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="walfareClick">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 由于未知的原因，这个dialog里的css样式都不起作用，所以样式就直接写在html元素的style属性里了 -->
    <el-dialog title="福利设置" :visible.sync="welVisible" width="40%">
      <div>
        <div
          style="display: flex;
            flex-direction: row;
            justify-content:space-around;margin-bottom:20px"
        >
          <el-input
            style="width:50%"
            placeholder="搜索员工"
            prefix-icon="el-icon-search"
            v-model="searchStr"
          ></el-input>
          <el-button style type="primary" @click="selAll">全选</el-button>
          <el-button type="success" @click="reset">重置</el-button>
        </div>
        <el-tree
          style="display:flex;flex-direction:row;flex-wrap:wrap;"
          :data="mates"
          v-if="welVisible"
          ref="mates"
          show-checkbox
          node-key="userId"
          :render-content="itemRender"
          :indent="0"
          @check-change="handleCheckChange"
          :filter-node-method="filterNode"
          :props="defaultProps"
        ></el-tree>
        <div style="display:flex;flex-direction:row;align-items:center;margin:10px;">
          <span style="width:20%;">福利金额(元)</span>
          <div style="width:80%">
            <el-input  v-model="currentMoney" placeholder="请输入福利金额"></el-input>
          </div>
        </div>
        <div style="display:flex;flex-direction:row;align-items:center;margin:10px;">
          <span style="width:20%;">备注</span>
          <div style="width:80%">
            <el-input type="textarea" v-model="currentTip" placeholder="请输入备注"></el-input>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="welVisible = false">取 消</el-button>
        <el-button type="primary" @click="getSelMates">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* 这个是福利审核被驳回时，点击修改福利，进来的页面，虽然本着代码复用的原则，直接用发福利比较合适，但是为了代码逻辑清晰可读性，还是分离开来了
  在这个页面中，基本的逻辑和发福利页面上是一样的，只不过数据需要初始化
 */
import { getMatesByCompanyId, welfareById } from '@/api/welfare'
export default {
  data () {
    return {
      mates: [], // 最开始的所有员工
      selMates: [], // 再组件上
      submitMates: [], //
      searchStr: '',
      companyId: '',
      ensureVisible: false,
      loading: false,
      welVisible: false,
      currentMoney: '',
      currentTip: '',
      orderId: 0,
      defaultProps: {
        children: 'children',
        label: 'realname'
      }
    }
  },
  computed: {
    matesCount: function () {
      let mates = []
      this.submitMates.forEach(arr => {
        mates = mates.concat(arr)
      })
      return mates.length
    },
    allMoney: function () {
      let money = 0
      this.submitMates.forEach(arr => {
        arr.forEach(e => {
          money += parseFloat(e.amount)
        })
      })
      return money.toFixed(2)
    }
  },
  mounted () {
    // console.log('reset mounted')
    this.companyId = localStorage.companyId
    this.getMates()
    this.orderId = this.store.state.welfare.id
    this.$nextTick(() => {
      this.$set(this.submitMates, 0, this.store.state.users)
    })
  },
  destroyed () {
  },
  watch: {
    searchStr: function (val) {
      this.$refs.mates.filter(val)
    }
  },
  methods: {
    /* tree组建的itme布局 */
    itemRender (h, { node, data, store }) {
      return h(
        'div',
        {
          style: `min-width:60px;${node.disabled ? 'pointer-events: none;' : ''}`, // 这个目前有没有生效待定
          on: {
            click: () => {
              if (!node.disabled) {
                node.checked = !node.checked
              }
            }
          }
        },
        data.realname
      )
    },
    /* 搜索 */
    filterNode (value, data) {
      if (!value) return true
      return data.realname.indexOf(value) !== -1
    },
    /* 点击事件 */
    handleCheckChange (data, checked, indeterminate) {
      // console.log(data, checked, indeterminate)
      // this.getSelMates()
    },

    selAll () {
      this.$refs.mates.setCheckedNodes(this.mates)
      // this.getSelMates()
    },
    reset () {
      this.$refs.mates.setCheckedNodes([])
      // this.getSelMates()
    },

    getSelMates () {
      if (!this.currentMoney <= 0) {
        this.$message('请输入正确的福利金额')
        return
      }

      this.selMates = this.$refs.mates.getCheckedNodes()// element提供的方法，获的tree上所有选中的节点
      if (this.selMates.length <= 0) {
        this.$message('请选择人员')
        return
      }
      this.welVisible = false

      let mates = []
      this.selMates.forEach(e => {
        e.amount = parseFloat(Math.abs(this.currentMoney)).toFixed(2)
        e.desc = this.currentTip
        e.disabled = true
        mates.push(e)
      })
      this.submitMates.push(mates)
      this.currentMoney = ''
      this.currentTip = ''
      // this.submitMates.concat(this.selMates);
      // this.reset()
    },
    /*
      移除某一个员工,是在submitMates这个二维数组里的某一个数组进行操作
      所以这个方法会传递两个值，一个是要移除的对象，一个是submitMates的索引
     */
    removeMate (obj, index) {
      let tempArr = this.submitMates[index]
      tempArr = tempArr.filter(e => e.userId !== obj.userId)
      if (tempArr.length <= 0) {
        this.$delete(this.submitMates, index)
      } else {
        this.$set(this.submitMates, index, tempArr)
      }
      this.selMates.forEach(e => {
        if (e.userId === obj.userId) {
          e.disabled = false
        }
      })
      this.mates.forEach(e => {
        if (e.userId === obj.userId) {
          e.disabled = false
        }
      })

      // this.submitMates[index] = tempArr;
    },
    addMatesClick () {
      this.welVisible = true
    },
    getMates () {
      getMatesByCompanyId(this.companyId).then(res => {
        this.mates = res.data
        this.selMates = this.store.state.users
        let ids = []
        this.selMates.forEach(e => {
          ids.push(e.userId)
        })
        this.mates.map(e => {
          if (ids.indexOf(e.userId) > -1) {
            // console.log(e.userId)
            e.disabled = true
          }
          return e
        })
      })
    },
    walfareClick () {
      this.loading = true
      this.ensureVisible = false
      let mates = []
      this.submitMates.forEach(arr => {
        mates = mates.concat(arr)
      })
      let data = {
        companyId: this.companyId,
        users: mates,
        orderId: this.orderId + ''
      }
      welfareById(data).then(res => {
        // console.log(res)
        if (res.msg === 'success') {
          this.$message({
            type: 'success',
            message: '已提交福利发放申请'
          })
          this.currentMoney = ''
          this.currentTip = ''
          this.submitMates = []
          this.selMates = []
          this.$router.replace('/welfarelist')
          this.loading = false
        } else {
          this.$message(res.msg)
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.welfare-main {
  .top-menu {
    width: 100%;
    margin: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .name-value {
      font-size: 16px;
      color: #526069;
      margin-right: 20px;
      >span{
        color: #f30;
      }
    }
  }
  .welfare-bottom {
    .wel-item {
      width: 100%;
      height: auto;
      margin-bottom: 20px;
      background: #fff;
      .tip{
        font-size: 12px;
        color: #333;
        margin: 15px 15px 0 0;
      }
    }
    .head-container {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-start;
      flex-wrap: wrap;
      .mate {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 118px;
        height: 48px;
        background: #f6f6f6;
        border-radius: 4px;
        position: relative;
        margin: 0 10px 10px 0;
        > i {
          position: absolute;
          right: -2px;
          top: -2px;
          color: #f00;
          cursor: pointer;
        }
        .name-money {
          height: 36px;

          .name {
            font-size: 12px;
            line-height: 18px;
            color: #333;
          }
          .money {
            font-size: 12px;
            line-height: 18px;
            color: #f30;
          }
        }

        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 18px;
          background: #67c23a;
          max-width: 100px;
          line-height: 36px;
          text-align: center;
          font-size: 16px;
          color: #fff;
          margin: 0 10px;
        }
      }
    }
    .empty-view{
      margin-top: 100px;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      >img{
        width: 214px;
        height: 214px;
      }
      >p{
        color: #7D8893;
        font-size: 16px;
      }
    }
  }
  .name-input{
    display: flex;
  }
}
</style>
